import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { DatePicker } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import { VueAxios } from './utils/request'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.use(DatePicker)
Vue.use(VueAxios)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
